import { render, staticRenderFns } from "./SmallBanners.vue?vue&type=template&id=0a1e38e8&scoped=true&"
import script from "./SmallBanners.vue?vue&type=script&lang=ts&"
export * from "./SmallBanners.vue?vue&type=script&lang=ts&"
import style0 from "./SmallBanners.vue?vue&type=style&index=0&id=0a1e38e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1e38e8",
  null
  
)

export default component.exports